import { render, staticRenderFns } from "./ChatBotButton.vue?vue&type=template&id=0631e978&"
import script from "./ChatBotButton.vue?vue&type=script&lang=js&"
export * from "./ChatBotButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports